module.exports = ".approvals-border {\n  border-left: 5px solid; }\n  .approvals-border.aprovacao-pendente {\n    border-left-color: #ffc107; }\n  .approvals-border.pagamento-pendente {\n    border-left-color: red; }\n  .approvals-border.pago {\n    border-left-color: #2ecc71; }\n  .approvals-border.aguardando-racional {\n    border-left-color: darkblue; }\n  .icon-color {\n  color: #ff6d00; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/approvals/project-listing/project-listing.component.scss
// module id = ./src/app/views/approvals/project-listing/project-listing.component.scss
// module chunks = main